module.exports = __webpack_public_path__ + "media/Portrait_Hintergrund.e0ddc549.mp4";